
export const contacts = [
  {group:'A', list:[
      {name:'Aaron Doe'},
      {name:'Archia Doe'},
  ]},
  
  {group:'B', list:[
    {name:'Bob Doe'},
    {name:'Bella Doe'},
  ]},
    
  {group:'J', list:[
    {name:'Johnny Doe'},
    {name:'Jonathan Doe'},
    {name:'Jennie Doe'},
    {name:'Jasmine Doe'},
    {name:'Jessica Doe'},
  ]},
  
  {group:'Z', list:[
    {name:'Zack Doe'},
  ]},

]